import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=d10236fe&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=ts"
export * from "./notifications.vue?vue&type=script&lang=ts"
import style0 from "./notifications.vue?vue&type=style&index=0&id=d10236fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10236fe",
  null
  
)

export default component.exports